<template>
    <div>
        <div class="core vx-col md:w-1/1 w-full mb-base">
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{this.dataEnd==0 ? 0: (this.limitShow * (this.isActive - 1) + 1)}} - {{this.limitShow * (this.isActive - 1) + dataEnd}} of {{this.recordsTotal}}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu>                
                            <vs-dropdown-item v-for="item in limits" v-bind:key="item" @click="changeLimit(item)">
                                <span>{{item}}</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
                <div class="mx-auto"></div>
                <div class="vx-col sm:w-1/3 w-full">
                    <div class="flex flex-wrap items-center justify-between">
                        <vs-input class="mb-4 md:mb-0 mr-4 w-full" v-model="search" placeholder="Search by : SO Code or Customer Name" />
                    </div>
                </div>
            </div>

            <vs-table :data="dataContract" stripe border>
                <template slot="thead">
                    <vs-th>Action</vs-th>
                    <vs-th>Contract</vs-th>
                    <vs-th>Customer</vs-th>
                    <vs-th>Company</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indexSO" v-for="(dt, indexSO) in data">
                        <vs-td>
                            <feather-icon v-if="dt.StatusApproval!=1" title="Edit" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click="clickEdit(dt)"/>
                            <feather-icon v-if="dt.StatusApproval==1" title="View" icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click="clickEdit(dt)"/>
                            <feather-icon title="Draft" icon="CalendarIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click="clickDraft(dt)"/>
                            <feather-icon v-if="dt.StatusApproval!=1" title="Delete" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="clickDelete(dt)"/>
                        </vs-td>
                        <vs-td>
                            Code : <b>{{dt.Code}}</b> <br>
                            Channel : {{dt.SalesChannelCode}} <br>
                            Total : {{ formatCurrency(dt.Total) }} <br>
                            Notes : {{dt.Notes}} <br>
                            Effective : {{ dateFormat(dt.DateStart) }} - {{ dateFormat(dt.DateEnd) }}
                        </vs-td>
                        <vs-td>
                            Code : {{dt.CustomerCode}} <br>
                            Name : {{dt.CustomerName}} <br>
                            <!-- Bill to : {{dt.BillAddress.Address}}, {{dt.BillAddress.City}}, {{dt.BillAddress.Country}}<br>
                            Ship to : {{dt.ShipAddress.Address}}, {{dt.ShipAddress.City}}, {{dt.ShipAddress.Country}}<br> -->
                        </vs-td>
                        <vs-td>
                            Code : {{dt.CompanyCode}} <br>
                            Name : {{dt.CompanyName}}
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
    
            <vs-pagination style="padding-top:5px" :total="maxPage" v-model="currentPage" :prev-icon="$vs.rtl ? 'arrow_forward' : 'arrow_back'" :next-icon="$vs.rtl ? 'arrow_back' : 'arrow_forward'"/>
        </div>
    </div>
</template>


<script>
// import detail from "../component/detail_selected_so.vue";
import moment from 'moment'

export default {
    components: {
        // detail
    },
    props: 
        ["territory", "salesChannel", "customerCategory"],
        data() {
            return {
                dataContract: [{
                    ContractLine: [{}],
                    Customer: {
                        Code: "",
                        Name: "",
                        Address: "",
                        Phone: "",
                        CustomerCategory: {
                            Name: ""
                        }
                    },
                    Company: {
                        Code: "",
                        Name: "",
                    },
                    SalesChannel: {
                        Code: "",
                        Name: ""
                    },
                    BillAddress: {
                        Address: "",
                        City: "",
                        Country: "",
                    },
                    ShipAddress: {
                        Address: "",
                        City: "",
                        Country: "",
                    },
                    Salesman: {
                        Name: "",
                    },
                    PaymentTerm: {
                        Name: "",
                    }
                }],
                contractCode: "",

                limits: [10, 25, 50, 100, "All"],
                limitShow: 10,
                drawData: 0,
                isActive: 1,
                search: "",
                recordsTotal: 0,
                maxPage: 2,
                dataEnd: 0,
            };
        },
    watch: {
        territory: function() {
            this.getData();
        },
        salesChannel: function() {
            this.getData();
        },
        customerCategory: function() {
            this.getData();
        },
        search: function() {
            this.getData();
        }
    },
    mounted() {
        // 
    },
    computed: {
        currentPage: {
            get() {
                return 1;
            },
            set(page) {
                this.page(page);
            }
        }
    },
    methods: {
        dateFormat(date) {
            if (date) {
                return moment(String(date)).utcOffset(0).format('DD/MM/YYYY')
            }
        },

        formatCurrency(nominal) {
            if(nominal) {
                nominal = (nominal/1).toFixed(2).replace('.', ',');
                return nominal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            } else {
                return 0;
            }
        },

        scrollToTop() {
            window.scrollTo(0,0);
        },

        getSOLine () {
            const search = this.contractCode;
            if (search) {
                this.selectedContract = this.dataContract.filter(so => so.Code.indexOf(search) > -1)[0] // filter + get 1st record
            }
        },

        clickSOCode(contract) {
            this.closeDetail();
            setTimeout(function() {}, 3000);
            this.contractCode = contract.Code;
            this.getSOLine();
            this.detail = true;
            this.scrollToTop();
        },

        clickEdit(contract) {
            this.$emit("selectContract", contract);
            this.$emit("redirectTab", 1);
        },

        clickDraft(contract) {
            this.$emit("selectContract", contract);
            this.$emit("redirectTab", 2);
        },

        clickDelete(contract) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "You are about to cancel '"+contract.Code+"' ?",
                accept: this.actionDelete,
                parameters: contract
            });
        },

        actionDelete(contract) {
            this.$vs.loading();
            this.$http
                .post("api/v1/closed-contract/delete", {
                    closed_contract_id: contract.DefaultAttribute.ID,
                })
                .then(resp => {
                    if (resp.code == 200) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: "Contract successfully deleted",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle"
                        });
                        this.getData();
                        this.$vs.loading.close();
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle"
                        });
                        this.getData();
                        this.$vs.loading.close();
                    }
            });
        },

        closeDetail() {
            this.detail = false;
            this.$emit("selectContract", null);
        },

        page(page) {
            this.getData(page);
            return page;
        },

        changeLimit(limit) {
            this.limitShow = limit;
            this.getData(this.isActive);
        },

        getData(page = 1) {
            if(this.territory != null && this.territory != "" && this.territory != undefined) {
                this.isActive = page;
                this.$vs.loading();

                this.$http.get("/api/v1/closed-contract", {
                    params: {
                        territory_code: this.territory,
                        sales_channel_code: this.salesChannel,
                        customer_category_id: this.customerCategory,
                        status_approval: 0,
                        search: this.search,
                        limit: this.limitShow,
                        offset: this.limitShow * (page - 1)
                    }
                }).then(resp => {
                    if (resp.code == 200) {
                        this.drawData = this.drawData + 1;
                        this.dataContract = resp.data.Contracts;
                        this.recordsTotal = resp.data.RecordsTotal;
                        this.maxPage = Math.ceil(this.recordsTotal / this.limitShow);
                        this.dataEnd = resp.data.ResultsTotal;
                        this.checkedAll = false;
                        this.$vs.loading.close();
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle"
                        });
                    }
                });
            }
        },
    }
};
</script>

<style>
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}
</style>